import {t} from 'i18next';

import {Product, ProductSearchResult} from 'types';
import {getDiscountDetailFromSlabTiers, getSlabPriceInfoText} from 'utils';
import {getWholeNumberOrTwoDecimal} from 'utils/common/shopify.util';

export type ProductPriceAndText = {
  product: Product | ProductSearchResult;
  productCount: number;
  defaultSlabPriceTire?: boolean;
};

export const useProductPriceAndText = (props: ProductPriceAndText) => {
  const {product, productCount, defaultSlabPriceTire = false} = props;

  const moq = product?.moq || 1;
  const slabPriceTiers = product.slabPrices?.slabPriceTiers || [];
  const isSlabPrice = (slabPriceTiers.length ?? 0) > 0;
  const showKg = product.isWeightedFresh;
  const quantity = showKg ? getWholeNumberOrTwoDecimal(productCount * moq) : productCount;
  const slabPriceQuantityParam = defaultSlabPriceTire ? 0 : quantity;
  const dynamicDiscount = getDiscountDetailFromSlabTiers(slabPriceTiers, slabPriceQuantityParam, product.displayPrice);
  const priceValue = dynamicDiscount.priceValue;
  const kgText = showKg ? ` /${t('labels.kg')}` : '';
  const productDisplayPrice = showKg ? priceValue / moq : priceValue;
  const discountPercentage = ((product?.originPrice - priceValue) / product?.originPrice) * 100;
  const slabPriceInfoText = getSlabPriceInfoText(dynamicDiscount, showKg);
  const productOriginalPrice = showKg ? product.originPrice / moq : product.originPrice;
  const isDiscounted = !!discountPercentage;
  const priceUnit = product.priceUnit;

  return {
    slabPriceTiers,
    isSlabPrice,
    showKg,
    kgText,
    priceValue,
    productDisplayPrice,
    discountPercentage,
    slabPriceInfoText,
    productOriginalPrice,
    isDiscounted,
    quantity,
    priceUnit
  };
};
